import React, { FC } from 'react'
// @src imports
import { Button, Icon } from 'src/chrome'

import { FlexColumn } from 'src/styled'
import { useAccount, useActions } from 'src/hooks'

// relative imports
import BaseCreditCard from '../BaseCreditCard/BaseCreditCard'

import styles from './styles'
import { Text } from '@sendoutcards/quantum-design-ui'

const PointsExpense: FC = props => {
  const account = useAccount()
  const actions = useActions()

  return (
    <BaseCreditCard css={{ backgroundColor: '#fff', border: 'none' }}>
      <FlexColumn css={styles.container}>
        <div css={styles.header}>
          <div css={styles.flex}>
            <Icon icon={'MONEY'} />
            <Text
              type="caption"
              color="primaryHeading"
              outset={{ top: 'x_25' }}
              inset={{ left: 'x1' }}
              weight="bold"
            >
              Points
            </Text>
          </div>
          <Button
            type={'button'}
            title={'Purchase More'}
            buttonColor={'blue'}
            style={{ margin: 0 }}
            onClick={actions.openPurchasePoints}
          />
        </div>
        <div css={{ ...styles.flex, ...styles.contents }}>
          <FlexColumn css={styles.flexColumn}>
            <span css={styles.amount}>{account.points.amount}</span>
            <Text type="caption" weight="bold">
              Points
            </Text>
          </FlexColumn>
        </div>
      </FlexColumn>
    </BaseCreditCard>
  )
}

export default PointsExpense
